"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ODataQuery = void 0;
var jinqu_1 = require("jinqu");
var shared_1 = require("./shared");
var ODataQuery = /** @class */ (function () {
    function ODataQuery(provider, parts) {
        if (parts === void 0) { parts = []; }
        this.provider = provider;
        this.parts = parts;
    }
    ODataQuery.prototype.withOptions = function (options) {
        return this.create(jinqu_1.QueryPart.create(jinqu_1.AjaxFuncs.options, [jinqu_1.PartArgument.literal(options)]));
    };
    ODataQuery.prototype.setParameter = function (key, value) {
        return this.withOptions({ params: [{ key: key, value: value }] });
    };
    ODataQuery.prototype.includeResponse = function () {
        var part = new jinqu_1.QueryPart(jinqu_1.AjaxFuncs.includeResponse, []);
        return this.create(part);
    };
    ODataQuery.prototype.inlineCount = function () {
        return this.create(jinqu_1.QueryPart.inlineCount());
    };
    ODataQuery.prototype.where = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        var part = new jinqu_1.QueryPart(shared_1.ODataFuncs.filter, [jinqu_1.PartArgument.identifier(predicate, scopes)]);
        return this.create(part);
    };
    ODataQuery.prototype.orderBy = function (keySelector) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.createOrderedQuery(jinqu_1.QueryPart.orderBy(keySelector, scopes));
    };
    ODataQuery.prototype.orderByDescending = function (keySelector) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.createOrderedQuery(jinqu_1.QueryPart.orderByDescending(keySelector, scopes));
    };
    ODataQuery.prototype.expand = function (nav, prm1, prm2) {
        var scopes = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            scopes[_i - 3] = arguments[_i];
        }
        var args = createExpandArgs.apply(void 0, __spread([nav, prm1, prm2], scopes));
        return this.createExpandedQuery(new jinqu_1.QueryPart(shared_1.ODataFuncs.expand, args));
    };
    ODataQuery.prototype.skip = function (count) {
        return this.create(jinqu_1.QueryPart.skip(count));
    };
    ODataQuery.prototype.take = function (count) {
        var part = new jinqu_1.QueryPart(shared_1.ODataFuncs.top, [jinqu_1.PartArgument.literal(count)]);
        return this.create(part);
    };
    ODataQuery.prototype.select = function () {
        var names = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            names[_i] = arguments[_i];
        }
        var part = new jinqu_1.QueryPart(shared_1.ODataFuncs.oDataSelect, [jinqu_1.PartArgument.literal(names)]);
        return this.provider.executeAsync(__spread(this.parts, [part]));
    };
    ODataQuery.prototype.groupBy = function (keySelector, elementSelector) {
        var scopes = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            scopes[_i - 2] = arguments[_i];
        }
        var args = [new jinqu_1.PartArgument(keySelector, null, scopes)];
        if (elementSelector) {
            args.push(new jinqu_1.PartArgument(elementSelector, null, scopes));
        }
        var part = new jinqu_1.QueryPart(shared_1.ODataFuncs.apply, args);
        return this.provider.executeAsync(__spread(this.parts, [part]));
    };
    ODataQuery.prototype.count = function (predicate) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.provider.executeAsync(__spread(this.parts, [jinqu_1.QueryPart.count(predicate, scopes)]));
    };
    ODataQuery.prototype.cast = function (ctor) {
        return this.create(jinqu_1.QueryPart.cast(ctor));
    };
    ODataQuery.prototype.toArrayAsync = function (ctor) {
        var query = ctor ? this.cast(ctor) : this;
        return query.provider.executeAsync(__spread(query.parts, [jinqu_1.QueryPart.toArray()]));
    };
    ODataQuery.prototype.toString = function () {
        var _a = __read(shared_1.handleParts(this.parts), 1), queryParams = _a[0];
        return queryParams.map(function (p) { return p.key + "=" + p.value; }).join("&");
    };
    ODataQuery.prototype.create = function (part) {
        return new ODataQuery(this.provider, __spread(this.parts, [part]));
    };
    ODataQuery.prototype.createOrderedQuery = function (part) {
        return new OrderedODataQuery(this.provider, __spread(this.parts, [part]));
    };
    ODataQuery.prototype.createExpandedQuery = function (part) {
        return new ExpandedODataQuery(this.provider, __spread(this.parts, [part]));
    };
    return ODataQuery;
}());
exports.ODataQuery = ODataQuery;
// tslint:disable-next-line:max-classes-per-file
var OrderedODataQuery = /** @class */ (function (_super) {
    __extends(OrderedODataQuery, _super);
    function OrderedODataQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderedODataQuery.prototype.thenBy = function (keySelector) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.createOrderedQuery(jinqu_1.QueryPart.thenBy(keySelector, scopes));
    };
    OrderedODataQuery.prototype.thenByDescending = function (keySelector) {
        var scopes = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            scopes[_i - 1] = arguments[_i];
        }
        return this.createOrderedQuery(jinqu_1.QueryPart.thenByDescending(keySelector, scopes));
    };
    return OrderedODataQuery;
}(ODataQuery));
// tslint:disable-next-line:max-classes-per-file
var ExpandedODataQuery = /** @class */ (function (_super) {
    __extends(ExpandedODataQuery, _super);
    function ExpandedODataQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExpandedODataQuery.prototype.thenExpand = function (nav, prm1, prm2) {
        var scopes = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            scopes[_i - 3] = arguments[_i];
        }
        var args = createExpandArgs.apply(void 0, __spread([nav, prm1, prm2], scopes));
        return this.createExpandedQuery(new jinqu_1.QueryPart(shared_1.ODataFuncs.thenExpand, args));
    };
    return ExpandedODataQuery;
}(ODataQuery));
function createExpandArgs(nav, prm1, prm2) {
    var scopes = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        scopes[_i - 3] = arguments[_i];
    }
    var selector;
    var filter;
    if (typeof prm1 !== "function" && typeof prm1 !== "string") {
        selector = prm1;
        filter = prm2;
    }
    else {
        filter = prm1;
        scopes = prm2 ? __spread([prm2], scopes) : scopes;
    }
    return [jinqu_1.PartArgument.literal(nav), jinqu_1.PartArgument.literal(selector), jinqu_1.PartArgument.identifier(filter, scopes)];
}
//# sourceMappingURL=odata-query.js.map